import { render, staticRenderFns } from "./ReportClassTip.vue?vue&type=template&id=2dcfe1e7&scoped=true"
import script from "./ReportClassTip.vue?vue&type=script&lang=ts"
export * from "./ReportClassTip.vue?vue&type=script&lang=ts"
import style0 from "./ReportClassTip.vue?vue&type=style&index=0&id=2dcfe1e7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfe1e7",
  null
  
)

export default component.exports